/**
 * 오른쪽 아래 퀵 버튼(.quickbar) — Alpine 컴포넌트.
 *
 * 맨 위로 버튼은 어느 정도 내려왔을 때만 보인다. 부드럽게 올라가는 것은
 * html 의 scroll-behavior: smooth 가 맡는다.
 *
 * 하단 작업 줄 위로 비켜 서는 일은 initStickyBar.js 가 문서에 다는 data-bar-stuck 을 보고 CSS 가 한다.
 *
 * <div class="quickbar" x-data="quickbar">
 *   <button x-show="scrolled" x-on:click="toTop()">…</button>
 * </div>
 */

// 이만큼 내려오면 맨 위로 버튼을 보인다. 첫 화면에서는 필요 없는 버튼이다.
const THRESHOLD = 300;

const quickbar = () => ({
  scrolled: false,

  init() {
    const sync = () => {
      this.scrolled = window.scrollY > THRESHOLD;
    };

    sync();
    window.addEventListener('scroll', sync, { passive: true });
  },

  toTop() {
    window.scrollTo({ top: 0 });
  },
});

export default quickbar;
